import styled from 'styled-components';
import { Styles } from '@gv/triage-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 16px;
  ${Styles.flexSpaceBetween};
`;
